import React from 'react';
import { Box, IconButton, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

/**
 * "Tuki ja ohjeet" at the very top of the sidebar, right under the search: support is
 * centralized there, and it has to be easier to find than the phone number.
 */
export function SidebarSupportButton({ onNavigate }) {
  const { t } = useTranslation();
  const active = useLocation().pathname === '/support';
  return (
    // The first row of the menu, styled exactly like the rows in MainNavigation (a framed box
    // here read as a form control next to the search). The light-blue icon is the only accent.
    <Box sx={{ px: 1.5, pt: 1.5 }}>
      <ListItemButton
        component={Link}
        to="/support"
        onClick={onNavigate}
        selected={active}
        data-testid="support-nav-button"
        sx={{
          borderRadius: '8px',
          py: 1.5,
          px: 2,
          color: active ? 'white' : 'rgba(255,255,255,0.85)',
          bgcolor: active ? 'rgba(255,255,255,0.15)' : 'transparent',
          '&:hover': { bgcolor: active ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)' },
          '&.Mui-selected': {
            bgcolor: 'rgba(255,255,255,0.15)',
            '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 40, color: '#90cdf4' }}>
          <HelpOutlineIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary={t('supportPage.navButton')}
          primaryTypographyProps={{ fontSize: '15px', fontWeight: 500 }}
        />
      </ListItemButton>
    </Box>
  );
}

/** Mobile: an icon in the AppBar next to search. */
export function MobileSupportButton() {
  const { t } = useTranslation();
  return (
    <IconButton
      color="inherit"
      component={Link}
      to="/support"
      aria-label={t('supportPage.navButton')}
      data-testid="support-nav-button-mobile"
    >
      <HelpOutlineIcon />
    </IconButton>
  );
}
